import { Collapse } from 'react-bootstrap';
import { SanityPlace } from '../../pages/CityGuide/CityGuide.types';
import { serializers } from '../../atoms/Legal/LegalBody/LegalBody';
const BlockContent = require('@sanity/block-content-to-react');

interface HighlightListProps {
  city: string;
  places: Array<SanityPlace>;
  showInfo: number | null; //Index of highlight to be shown
  setShowInfo: Function;
}

function HighlightsList({ city, places, showInfo, setShowInfo }: HighlightListProps) {
  const handleOnClick = (index: number) => {
    setShowInfo((!!index || index === 0) && index !== showInfo ? index : null);
  };

  return (
    <div className="col-12 highlight-list">
      <h2 className="highlight-list-header pb-2">Urbain's When in {city}</h2>
      {!!places &&
        !!places.length &&
        places.map((each: SanityPlace, index: number) => (
          <div
            key={`${index}-highlight`}
            className={'pointer mb-2'}
            onClick={() => {
              handleOnClick(index);
            }}
          >
            <h4 className="highlight-list-item">
              {index + 1}. {each.name}
            </h4>
            <Collapse in={showInfo === index}>
              <div className={'p-2'}>
                <BlockContent blocks={each.description} serializers={serializers} />
                <p>Phone: {each.phone}</p>
                <p>
                  Web: <a href={each.webUrl}>{each.webUrl}</a>
                </p>
              </div>
            </Collapse>
          </div>
        ))}
    </div>
  );
}

export default HighlightsList;
